<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Pick Location</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="map" #map></div>
</ion-content>
